import { render } from "./ViewProjects.vue?vue&type=template&id=6e0e46bc&scoped=true"
import script from "./ViewProjects.vue?vue&type=script&lang=js"
export * from "./ViewProjects.vue?vue&type=script&lang=js"

import "./ViewProjects.vue?vue&type=style&index=0&id=6e0e46bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0e46bc"]])

export default __exports__